module.exports = "/images/when-in-manila.png?4bdac72d658f476756baa1eb0c6ade84";